import { PageContainer, PageHeader } from '../../components/Layout'
import { Button, Card, CardContent, Badge } from '../../components/UI'
import { useRentalTechData } from './useRentalTechData'
import { rentalTechService } from '../../services/api'

export default function RentalTechMaintenance() {
  const { maintenance, equipments, refresh } = useRentalTechData()

  const autoGenerate = async () => {
    await rentalTechService.autoMaintenance()
    await refresh()
  }

  const equipmentName = (id) => equipments.find((e) => e.id === id)?.name || id

  return (
    <PageContainer>
      <div className="space-y-6">
        <PageHeader
          title="Mantenimiento Preventivo y Correctivo (SAT)"
          subtitle="Generacion automatica por horas de uso y/o vibracion"
          actions={<Button onClick={autoGenerate}>Generar Preventivo Automatico</Button>}
        />

        <Card>
          <CardContent className="p-0 overflow-x-auto">
            <table className="w-full text-sm min-w-[760px]">
              <thead className="bg-gray-50 border-b">
                <tr className="text-left">
                  <th className="px-4 py-3">Equipo</th>
                  <th className="px-4 py-3">Tipo</th>
                  <th className="px-4 py-3">Disparador</th>
                  <th className="px-4 py-3">Costo Est.</th>
                  <th className="px-4 py-3">Estado</th>
                </tr>
              </thead>
              <tbody>
                {maintenance.map((row) => (
                  <tr key={row.id} className="border-b">
                    <td className="px-4 py-3">{equipmentName(row.equipment_id)}</td>
                    <td className="px-4 py-3">{row.type}</td>
                    <td className="px-4 py-3">{row.trigger_source || 'manual'}</td>
                    <td className="px-4 py-3">${Number(row.estimated_cost || 0).toLocaleString()}</td>
                    <td className="px-4 py-3"><Badge variant={row.status === 'closed' ? 'success' : 'warning'}>{row.status}</Badge></td>
                  </tr>
                ))}
                {!maintenance.length ? (
                  <tr>
                    <td colSpan={5} className="px-4 py-10 text-center text-gray-500">Sin ordenes por ahora.</td>
                  </tr>
                ) : null}
              </tbody>
            </table>
          </CardContent>
        </Card>
      </div>
    </PageContainer>
  )
}
